import Builder from '../../utils/redux/builder'
import { mockGame, requestCache, saveAuth } from '../../api/user'
import { addTimer, removeTimer } from '../../utils/timer/TimerWrapper'

const attemptsKeys = new Set([
  'newFreeAttempts',
  'attempts',
  'attemptsCooldown',
  'attemptsRestoredAt',
])

/**
 * slice name
 * @type {string}
 */

const builder = new Builder({
  name: 'user',
  initialState: {
    profile: null,
    attemptsTimer: null,
    games: null,
    isFirstEntry: null,
    favorites: null,
    completedUserData: {},
  },
  reducers: {
    change(state, { payload: { key, value } }) {
      state[key] = value
      key === 'profile' && saveAuth({ profile: value })
    },
    changeProfile(state, { payload }) {
      const filteredPayload = {}
      for (const key in payload) {
        if (attemptsKeys.has(key)) continue
        filteredPayload[key] = payload[key]
      }
      const newProfile = { ...state.profile, ...filteredPayload }
      state.profile = newProfile
      saveAuth({ profile: newProfile })
    },
    resetFriends(state) {
      state.favorites = null
    },
    setCompletedUserData(state, { payload: completedUserData }) {
      state.completedUserData = completedUserData
    },
    applyPendingGachaReward(state, { payload }) {
      if (payload?.profile) {
        const mutationProfile = {}
        for (const key in payload.profile) {
          if (attemptsKeys.has(key)) continue
          mutationProfile[key] = payload.profile[key]
        }
        state.profile = { ...(state.profile ?? {}), ...mutationProfile }
      }

      const prizes = payload?.prizes
      if (!prizes || !state?.profile?.items) return
      prizes.forEach((prize) => {
        if (!payload?.quest?.prize?.hasOwnProperty('shopItem')) return
        const eventPrizes = Object.entries(prize ?? {})
          ?.reduce(
            (acc, [key, value]) => (key.includes('shopItem') && !!value ? [...acc, value] : acc),
            [],
          )
          ?.map?.((clothItem) => ({ ...clothItem, is_equipped: false }))
        if (eventPrizes) state.profile.items = [...state.profile.items, ...eventPrizes]
      })
    },
  },
})
  .addMatcher(
    () => true,
    (state, { payload = {}, type }) => {
      if (type === 'requests/gacha/open/fulfilled') return
      if (!payload?.hasOwnProperty?.('profile')) return

      const mutationProfile = {}
      for (const key in payload.profile) {
        if (attemptsKeys.has(key)) continue
        mutationProfile[key] = payload.profile[key]
      }
      state.profile = { ...(state.profile ?? {}), ...mutationProfile }
    },
  )
  .createExtraReducer({
    thunkName: 'match3/load-game',
    thunkExtraName: 'm3LoadGame',
    saveData(
      state,
      {
        payload: { games },
        meta: {
          arg: { onComplete },
        },
      },
    ) {
      state.games = games
      onComplete?.({ games })
    },
    async func({ loadingPromise }) {
      await Promise.all([loadingPromise, requestCache.profile])
      const { games } = await mockGame()
      return { games }
    },
  })
  .addExtraReducer({
    'requests/user/get-favorites/fulfilled'(state, { payload }) {
      const filteredNewFavorites = payload?.items?.filter(({ uid }) => {
        return !state.favorites?.some(({ uid: prevId }) => prevId === uid)
      })

      state.favorites = Array.isArray(state.favorites)
        ? [...state.favorites, ...(filteredNewFavorites ?? [])]
        : payload?.items
    },
  })
  .addExtraReducer({
    'requests/user/add-friend/fulfilled'(state, { payload }) {
      const { user } = payload
      state.favorites = [user, ...(Array.isArray(state.favorites) ? state.favorites : [])]
    },
  })
  .addExtraReducer({
    'requests/user/auth/fulfilled'(state, { payload }) {
      console.log('GA TMG [Auth] 4️⃣ Авторизация успешна, профиль сохранен', { payload })
      state.isFirstEntry = payload?.userStatus === 'New'
    },
  })
  .addExtraReducer({
    'requests/user/beauties-balance/fulfilled'(state, { payload }) {
      state.profile.beauties = payload?.beautiesAmount ?? null
      // timestamp последнего обновления баланса бьютисов .
      state.profile.lastBeautiesBalanceUpdate = Date.now()
    },
  })
  .addExtraReducer({
    'requests/user/attempts/fulfilled'(state, { payload }) {
      if (!payload?.profile) return

      state.profile = {
        ...(state.profile ?? {}),
        ...payload.profile,
      }
      state.attemptsTimer && removeTimer(state.attemptsTimer)
      state.attemptsTimer = addTimer({ duration: state.profile?.attemptsCooldown * 1000 })
    },
  })
  .addExtraReducer({
    'requests/user/prizes/fulfilled'(state, { payload }) {
      if (!payload?.prizes) return

      state.profile = {
        ...(state.profile ?? {}),
        prizes: payload.prizes,
      }
    },
  })
  /* .addExtraReducer({"requests/game/start-hidden-object/fulfilled"(state, {payload}) {
    state.profile.items = payload.items;
  }
})

.addExtraReducer({"requests/game/end-hidden-object/fulfilled"(state, {payload}) {
    state.profile.items = payload.profile.items;
  }
})

.addExtraReducer({"requests/game/exit-hidden-object/fulfilled"(state, {payload}) {
    if (state?.profile) state.profile.items = payload.profile.items;
  }
}) */

  .addExtraReducer({
    'requests/game/collect-quest/fulfilled'(state, { payload }) {
      if (!payload?.quest?.prize?.hasOwnProperty('shopItem')) return
      const prize = payload?.quest?.prize
      const eventPrizes = Object.entries(prize ?? {})
        ?.reduce(
          (acc, [key, value]) => (key.includes('shopItem') && !!value ? [...acc, value] : acc),
          [],
        )
        ?.map?.((clothItem) => ({ ...clothItem, is_equipped: false }))
      if (eventPrizes) state.profile.items = [...state.profile.items, ...eventPrizes]
    },
  })

builder.create()

const user = builder.export()

export default user

export const { useUser } = user.selectors
